import { Component, Input, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-yandex-ad-main-mobile-header',
  template: '<div [style]="safeCss(this.style)"><div id="yandex_rtb_{{blockId}}"></div></div>',
})
export class YandexAdMainMobileHeaderComponent implements AfterViewInit {
  @Input() blockId: string;
  @Input() style: string;
  
  constructor(private doms: DomSanitizer) {}
  
  safeCss(style) {
    return this.doms.bypassSecurityTrustStyle(style);
  }

  ngAfterViewInit() {
	// Находим div с классом header__menu-burger
		const menuBurger = document.querySelector('.header__menu-burger');

		// Переменная для отслеживания состояния блока
		let isAdVisible = false;

		// Обработчик события для кнопки меню
		menuBurger.addEventListener('click', () => {
		  if (!isAdVisible) {
			// Если блок еще не отображен, показываем его
			// @ts-ignore
			window.yaContextCb.push(() => {
			  // @ts-ignore
			  Ya.Context.AdvManager.render({
				blockId: this.blockId,
				renderTo: 'yandex_rtb_' + this.blockId,
			  });
			});
			isAdVisible = true; // Устанавливаем флаг видимости блока в true
		  } else {
			// Если блок уже отображен, удаляем его
			// @ts-ignore
			window.yaContextCb.push(() => {
			  // @ts-ignore
			  Ya.Context.AdvManager.destroy({
				blockId: this.blockId
			  });
			});
			isAdVisible = false; // Устанавливаем флаг видимости блока в false
		  }
		});
		
		// Получаем все ссылки внутри .mobile-menu
		const menuItems = document.querySelector('.mobile-menu').querySelectorAll('nav');
		// Преобразуем NodeList в массив
		const menuElements = Array.from(menuItems);

		// Добавляем обработчик события для каждого элемента
		menuElements.forEach(item => {
		  item.addEventListener('click', () => {
			// Удаляем блок при нажатии на любой элемент меню
			// @ts-ignore
			window.yaContextCb.push(() => {
			  // @ts-ignore
			  Ya.Context.AdvManager.destroy({
				blockId: this.blockId
			  });
			});
			// Устанавливаем флаг видимости блока в false при нажатии на элемент меню
			isAdVisible = false;
		  });
		});
	}
}
